const noop = () => {}

const state = {
  open: false,
  message: '',
  onClose: noop,
}

const mutations = {
  OPEN(state, { message, onClose }) {
    state.open = true
    state.message = message

    if (typeof onClose === 'function') {
      state.onClose = onClose
    }
  },
  CLOSE(state) {
    state.open = false
    state.message = ''
    state.onClose = noop
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
